import React from 'react';
import '../CSS/Profile/JenniferBarfieldProfile.css';

const JenniferBarfieldProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jennifer-h-barfield-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Jennifer H. Barfield"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Jennifer H. Barfield</h1>
        <div className="profile-title-container">
          <p className="profile-title">Executive Vice President and Consultant</p>
          <a href="https://www.linkedin.com/in/jennifer-barfield-m-ed-72b77110/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Jennifer H. Barfield serves as Executive Vice President and Consultant of Myers McRae. As a search consultant, she works directly with colleges and universities on the recruitment and evaluation of candidates to fulfill their search needs. She brings more than 20 years of experience in education in fundraising, public relations, program development, strategic planning, and alumni and donor relations to our clients. Her career ranges from a private college-preparatory school, First Presbyterian School; a private university, Mercer University; and a state university, Middle Georgia State University.
          </p>
          <p>
            The majority of her career has been in institutional advancement, serving leadership roles in state and private universities. For 13 years, she was the Associate Vice President for Donor and Foundation Relations at Mercer University. While at the university, she coordinated the $350 million Advancing the Vision Campaign, the largest fundraising campaign in Mercer's history at that time, working directly for the Senior Vice President for Advancement and a team of development professionals.
          </p>
          <p>
            In 2008, she was named Director of Institutional Advancement and the Foundation at Middle Georgia College and, later, became the Assistant Vice President for Development and Alumni Affairs for Middle Georgia State University.
          </p>
          <p>
            Prior to her career in education, she worked in non-profit management and volunteer management, including serving as Community Director of Middle Georgia March of Dimes.
          </p>
          <p>
            A graduate of Mercer University with a Bachelor of Arts degree in Communication, Ms. Barfield holds a master's degree in Higher Education Administration, summa cum laude, from Georgia Southern University.
          </p>
        </div>
      </div>
    </div>
  );
};

export default JenniferBarfieldProfile;

